import styled from 'styled-components';

export const Portal = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition: opacity 240ms ease;
`;

export const Content = styled.div`
  width: 520px;
  max-width: 95%;
  height: 100%;
  background: ${({ theme }) => theme.colors.white || '#fff'};
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  padding: 16px;
  transform: translateX(${({ $open }) => ($open ? '0' : '100%')});
  transition: transform 240ms cubic-bezier(0.2, 0.8, 0.2, 1);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
`;

export const Title = styled.div`
  font-weight: 800;
  font-size: 24px;
  line-height: 1;
  margin-bottom: 2px;
`;

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 6px;
`;

export const Body = styled.div`
  flex: 1;
  overflow: auto;
  padding-top: 8px;
`;

/* Card and related elements for connection UI */
export const Card = styled.div`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  background: ${({ theme }) => theme.colors.white || '#fff'};
`;

export const CardHeader = styled.div`
  font-weight: 700;
  margin-bottom: 12px;
  font-size: 15px;
`;

export const CardBody = styled.div`
  padding: 4px 0 0 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed rgba(0,0,0,0.04);
  &:last-child { border-bottom: none; }
`;

export const QRWrap = styled.div`
  width: 180px;
  height: 180px;
  background: #fafafa;
  border: 1px dashed rgba(0,0,0,0.06);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 50px auto 50px auto;

  img {
    width: 88%;
    height: 88%;
    object-fit: contain;
    margin-top: 12px;
  }
`;

export const Placeholder = styled.div`
  color: rgba(0,0,0,0.25);
  font-size: 13px;
`;

export const Label = styled.div`
  color: rgba(0,0,0,0.6);
  font-size: 13px;
  flex: 0 0 auto;
  margin-right: 12px;
`;

export const Value = styled.div`
  font-size: 14px;
  font-weight: 600;
  flex: 1 1 auto;
  text-align: right;
  word-break: break-word;
`;

export const InstructionCard = styled.div`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 10px;
  padding: 12px;
  margin-top: 8px;
  background: ${({ theme }) => theme.colors.white || '#fff'};
`;

export const StartButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 12px;
`;
